<template>
  <b-nav-item-dropdown
    no-caret
    class="dropdown-resources"
    menu-class="resources-dropdown-menu shadow-lg border-0"
    toggle-class="d-flex align-items-center p-0 nav-link-icon"
    @show="onDropdownShow"
    @hide="onDropdownHide"
  >
    <template #button-content>
      <img
        alt="resource"
        class="cursor-pointer resource-nav-img"
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1ncmlwIHByZXZpZXctaWNvbiI+PGNpcmNsZSBjeD0iMTIiIGN5PSI1IiByPSIxIi8+PGNpcmNsZSBjeD0iMTkiIGN5PSI1IiByPSIxIi8+PGNpcmNsZSBjeD0iNSIgY3k9IjUiIHI9IjEiLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxIi8+PGNpcmNsZSBjeD0iMTkiIGN5PSIxMiIgcj0iMSIvPjxjaXJjbGUgY3g9IjUiIGN5PSIxMiIgcj0iMSIvPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTkiIHI9IjEiLz48Y2lyY2xlIGN4PSIxOSIgY3k9IjE5IiByPSIxIi8+PGNpcmNsZSBjeD0iNSIgY3k9IjE5IiByPSIxIi8+PC9zdmc+"
      >
    </template>

    <div class="resources-dropdown-content">
      <h6 class="resources-heading font-weight-bolder mb-0">
        Resources
      </h6>

      <!-- Horizontal Divider -->
      <hr class="resources-divider">

      <div class="resources-grid">
        <!-- Rider App -->
        <a
          :href="apkUrl"
          target="_blank"
          class="resource-card text-decoration-none"
        >
          <div class="resource-icon-box bg-light-red">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#f45d48"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="resource-card-icon"
            >
              <rect
                width="14"
                height="20"
                x="5"
                y="2"
                rx="2"
                ry="2"
              />
              <path d="M10 5h4" />
              <path d="M10 19h4" />
            </svg>
          </div>
          <span class="resource-label">Rider App</span>
        </a>

        <!-- Merchant Portal -->
        <a
          :href="getMerchantPortalURL"
          target="_blank"
          class="resource-card text-decoration-none"
        >
          <div class="resource-icon-box bg-light-blue">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#288fee"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="resource-card-icon"
            >
              <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
              <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
              <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
              <path d="M2 7h20" />
              <path d="M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 10V7" />
            </svg>
          </div>
          <span class="resource-label">Merchant Portal</span>
        </a>

        <!-- API Documentation -->
        <a
          :href="getAPIDocumentationURL"
          target="_blank"
          class="resource-card text-decoration-none"
        >
          <div class="resource-icon-box bg-light-purple">
            <feather-icon
              icon="FileTextIcon"
              class="resource-card-icon icon-purple"
            />
          </div>
          <span class="resource-label">API Documentation</span>
        </a>

        <!-- Tracking Page -->
        <a
          :href="getTrackingLink()"
          target="_blank"
          class="resource-card text-decoration-none"
        >
          <div class="resource-icon-box bg-light-orange">
            <feather-icon
              icon="MapPinIcon"
              class="resource-card-icon icon-orange"
            />
          </div>
          <span class="resource-label">Tracking Page</span>
        </a>
      </div>
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown } from 'bootstrap-vue'
import {
  appEnv, bucketUrl, tenant, merchantPortalUrl, apiDocumentationUrl,
} from '@/constants/config'

export default {
  name: 'ResourcesDropdown',
  components: {
    BNavItemDropdown,
  },
  data() {
    return {
      merchantPortalUrl,
      apiDocumentationUrl,
    }
  },
  computed: {
    apkUrl() {
      const appName = appEnv === 'production' ? tenant : `${tenant}dev`
      return `${bucketUrl}apk/app-${appName}-release.apk`
    },
    getMerchantPortalURL() {
      return merchantPortalUrl
    },
    getAPIDocumentationURL() {
      return apiDocumentationUrl
    },
  },
  beforeDestroy() {
    // Cleanup if component unmounts while open
    this.onDropdownHide()
  },
  methods: {
    onDropdownShow() {
      const parent = this.$el.closest('.navbar-scrollable')
      if (parent) {
        parent.classList.add('resources-menu-open')
      }
    },
    onDropdownHide() {
      const parent = this.$el.closest('.navbar-scrollable')
      if (parent) {
        parent.classList.remove('resources-menu-open')
      }
    },
    getTrackingLink() {
      if (this.appEnv === 'local') {
        return 'http://localhost:3000'
      }
      if (this.appEnv === 'staging' || window.location.origin.split('.')[1] === 'office') {
        return window.location.origin.replaceAll('office', 'tracking')
      }

      // if url inlude curfox return below one
      if (window.location.host.includes('curfox')) {
        return `https://${tenant}.tracking.curfox.com`
        // eslint-disable-next-line no-else-return
      } else {
        // else replace office/merchant with tracking
        return window.location.origin.replaceAll('office', 'tracking')
      }
    },
  },
}
</script>

<!-- UNSCOPED GLOBAL STYLES -->
<style lang="css">
.navbar-scrollable.resources-menu-open {
  overflow: visible !important;
}

.dropdown-resources {
  position: relative !important;
}

/* Desktop dropdown style */
.dropdown-resources .dropdown-menu.resources-dropdown-menu {
  width: 330px !important;
  min-width: 330px !important;
  max-width: 330px !important;
  height: auto !important;
  min-height: auto !important;
  max-height: none !important;
  padding: 0 !important;
  background-color: #ffffff !important;
  border-radius: 16px !important;
  margin-top: 18px !important;
  overflow: visible !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;

  /* Centered under the icon on Desktop */
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%) !important;
}

.dropdown-resources .dropdown-menu.resources-dropdown-menu * {
  max-height: none !important;
}

/* Pointer arrow */
.dropdown-resources .dropdown-menu.resources-dropdown-menu::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%) rotate(45deg) !important;
  width: 16px;
  height: 16px;
  background-color: #ffffff !important;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  border-left: 1px solid rgba(0, 0, 0, 0.05);
}

.header-navbar .navbar-container ul.navbar-nav li.dropdown .dropdown-menu.resources-dropdown-menu {
    top: 20px !important;
}

@media (max-width: 767px) {
    .header-navbar .navbar-container .show .dropdown-menu.resources-dropdown-menu {
        left: 50% !important;
    }

    .dropdown-resources .dropdown-menu.resources-dropdown-menu {
        width: 250px !important;
        min-width: 250px !important;
        max-width: 250px !important;
    }
}

/* Dark mode overrides */
.dark-layout .dropdown-resources .dropdown-menu.resources-dropdown-menu,
.dark-layout .dropdown-resources .dropdown-menu.resources-dropdown-menu .resources-dropdown-content {
  background-color: #283046 !important;
}

.dark-layout .dropdown-resources .dropdown-menu.resources-dropdown-menu::before {
  background-color: #283046 !important;
  border-color: rgba(255, 255, 255, 0.05) !important;
}
</style>

<!-- SCOPED STYLES -->
<style lang="css" scoped>
.dropdown-resources {
  list-style: none;
  margin: 0 8px;
}

.resource-nav-img {
  width: 20px;
  height: 20px;
}

.resources-dropdown-content {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 20px 20px 22px !important;
  background-color: #ffffff;
  border-radius: 10px;
}

.resources-heading {
  color: #5e5873;
  font-size: 16px;
}

/* Divider Line */
.resources-divider {
  margin: 14px -20px 18px -20px;
  border: 0;
  border-top: 2px solid #ebe9f19c;
}

.dark-layout .resources-divider {
  border-top-color: #3b4253;
}

.resources-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 18px;
  column-gap: 16px;
}

.resource-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.15s ease-in-out;
  user-select: none;
}

.resource-card:hover,
.resource-card:active {
  transform: translateY(-2px);
}

.resource-icon-box {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.resource-card-icon {
  width: 26px;
  height: 26px;
}

.resource-label {
  font-size: 13px;
  font-weight: 600;
  color: #4b465c;
  line-height: 1.25;
}

@media (max-width: 767px) {
    .resource-nav-img {
        width: 15px;
        height: 15px;
    }

    .resources-dropdown-content {
        padding: 16px !important;
    }

    .resources-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        row-gap: 16px;
        column-gap: 8px;
    }

    .resources-heading {
        font-size: 14px;
    }

    .resource-icon-box {
        width: 50px;
        height: 50px;
    }

    .resource-card-icon {
        width: 20px;
        height: 20px;
    }

    .resource-label {
        font-size: 11px;
        overflow-wrap: anywhere;
    }
}

/* Background & Icon colors */
.bg-light-red {
  background-color: #fdeeee;
}
.icon-red {
  stroke: #ff684a;
}

.bg-light-blue {
  background-color: #eaf3fe;
}

.bg-light-purple {
  background-color: #f4eeff;
}
.icon-purple {
  stroke: #9b51e0;
}

.bg-light-orange {
  background-color: #fdf5e7;
}
.icon-orange {
  stroke: #f2994a;
}

/* Dark mode text colors */
.dark-layout .resources-heading,
.dark-layout .resource-label {
  color: #d0d2d6 !important;
}
</style>
